import { useEffect, useState } from "react";
import { Printer, X, Sparkles } from "lucide-react";
import api from "@/lib/api";

const dismissKey = (year) => `car-tags-reminder-dismissed-${year}`;

export function CarTagsReminder({ onPrint }) {
  const [status, setStatus] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    api.get("/students/car-numbers/status")
      .then((r) => {
        setStatus(r.data);
        setHidden(localStorage.getItem(dismissKey(r.data.year)) === "1");
      })
      .catch(() => {});
  }, []);

  if (!status?.show_print_reminder || hidden) return null;

  const start = new Date(`${status.start_date}T00:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });
  const reissued = Boolean(status.reissued_at);
  const dismiss = () => {
    localStorage.setItem(dismissKey(status.year), "1");
    setHidden(true);
  };

  return (
    <div data-testid="car-tags-reminder" className="mb-6 flex flex-wrap items-center gap-4 rounded-xl border border-amber-200 bg-amber-50 px-5 py-4">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700">
        <Sparkles className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="font-semibold text-amber-900" data-testid="car-tags-reminder-title">
          New school year — {reissued ? "car numbers were re-issued" : "school year started"} on {start}
        </div>
        <div className="text-sm text-amber-800">
          {status.car_riders} car rider{status.car_riders === 1 ? "" : "s"} need new dashboard tags.
          {status.notified_at ? " Parents have been emailed their child's new number." : ""} Print the full set for the front office.
        </div>
      </div>
      <button
        type="button"
        onClick={onPrint}
        data-testid="car-tags-reminder-print"
        className="inline-flex items-center gap-2 rounded-lg bg-amber-600 px-4 py-2 text-sm font-medium text-white hover:bg-amber-700 transition"
      >
        <Printer className="h-4 w-4" /> Print all car tags
      </button>
      <button type="button" onClick={dismiss} data-testid="car-tags-reminder-dismiss" aria-label="Dismiss" className="rounded-md p-1.5 text-amber-700 hover:bg-amber-100 transition">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
